import { render } from "./booking-completed.vue?vue&type=template&id=86b44a90"
import script from "./booking-completed.vue?vue&type=script&lang=js"
export * from "./booking-completed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__